export const optionsFilterPipeline = [
    { name: 'Name', value: 'name', direction: 'asc' },
    { name: 'Sales', value: 'total_sales', direction: 'desc' },
    { name: 'Sales estimated', value: 'estimated_sales', direction: 'desc' },
    { name: 'Effectiveness ratio', value: 'effectiveness_ratio', direction: 'desc' }
]